import { Controller } from "@hotwired/stimulus"
import hljs from "highlight.js/lib/core"
import json from "highlight.js/lib/languages/json"

// Low-weight: pull highlight.js core (~tiny) plus only the languages we actually
// render. Today that's just JSON (via `json_codeblock`). To add another language,
// import it and register it here — each is only a few KB:
//   import ruby from "highlight.js/lib/languages/ruby"
//   hljs.registerLanguage("ruby", ruby)
hljs.registerLanguage("json", json)

export default class extends Controller {
  connect() {
    // Guard against re-highlighting a Turbo-cached element (avoids the
    // "already highlighted" warning and double-wrapped markup).
    if (this.element.dataset.highlighted === "yes") return

    hljs.highlightElement(this.element)
  }
}
